<template>
    <div style="margin: -12px -12px -12px -12px;" data-aos-easing="ease" data-aos-duration="400" data-aos-delay="0" v-resize="onResize">
            <!-- {{imgPath}} -->
      <section v-if="false" class="home-section home-fade home-full-height bg-dark-60 landing-header parallax-bg aos-init" id="home" :style="'background-image: url(' + baseUrl + 'img/webapp/fon.jpg); min-height: '+ (isMobile ? 380 : 600) + 'px;'" v-intersect="onIntersectSection1">
        <div class="titan-caption">
          <div class="caption-content" style="position: relative;">
            <v-slide-y-reverse-transition hide-on-leave>
            <div class="container container-section-landing pb-0 mb-0" v-if="loadedPage">
              <v-row :class="{'mt-16': !isMobile, 'mt-5': isMobile}">
                <v-col cols="12" lg="3">
                  <!-- data-aos="fade-right"
                    data-aos-easing="ease-out-back" class="aos-init"
                    :class="{'aos-animate' : isIntersecting.section1}" -->
                  <svg v-if="isSvgLogo" class="_icon-logo" :style="isDark ? 'color:#3a84f3':'color:#11519c'">
                    <use href="/img/webapp/logoSVG.svg#logo"></use>
                  </svg>
                  <!-- <svgIcon v-if="isSvgLogo" iconName="logo" fill="#ffffff" :width="isMobile ? 70 : 250" :height="80"></svgIcon> -->
                  <v-img
                    v-else
                    style="margin: 0 auto;"
                    max-height="500"
                    :max-width="isMobile ? 70 : 250"
                    :src="baseUrl + 'img/webapp/dstuWhite.png'"
                  ></v-img>
                </v-col>
                <v-col cols="12" lg="6" class="pa-5" >
                  <div class="mb-0">
                    <div class="text-left white--text mb-0" :class="{'text-center' : isMobile, 'site-title': !isMobile, 'site-title-mobile': isMobile}">{{initInfo.homeTitul ? initInfo.homeTitul : 'Электронная информационно-образовательная среда ДГТУ'}}</div>
                    <p class="white--text mt-8" :style="{'font-size': isMobile ? '16px': '20px'}" style="font-weight: 400;" :class="{'text-center' : isMobile}">{{initInfo.homeTextBlock1 ? initInfo.homeTextBlock1 : 'Данный сайт представляет собой Интернет-расширение информационной системы ДГТУ, созданное для студентов, их родителей и сотрудников университета.'}}</p>
                  </div>
                  <div v-if="false" class="mt-8">
                    <v-btn
                      rounded
                      v-for="(item) in mainMenuItems" :key="item.menuItemID"
                      :color="'white'"
                      class="mr-6 mb-6 text--primary"
                      :class="{'ml-0' : isMobile}"
                      :href="item.href"
                      :target="item.newTab === true ? '_blank' : ''"
                      :small="isMobile"
                    >
                      {{item.text}}
                    </v-btn>
                  </div>

                </v-col>
              </v-row>
              <!-- <div class="font-alt mb-30 titan-title-size-4">Landing Page</div>
              <div class="font-alt">Create a stylish App Landing Page<br>And highlight all the great things of your product!</div>
              <div class="font-alt mt-30"><a class="btn btn-border-w btn-circle" href="#"><i class="icon-download"></i> Download App</a></div> -->
            </div>
            </v-slide-y-reverse-transition>
          </div>
        </div>
      </section>
      <v-fade-transition>
      <section v-if="loadedPage && mainMenuItems.filter(f => f.section).length > 0 && false" class="container container-section-landing pt-6">
        <div class="mx-0">
          <v-row >
            <v-col class="px-0" cols="12" lg="12" xl="12" v-if="mainMenuItems.filter(f => $router.currentRoute.path && f.section && $router.currentRoute.path.toLowerCase().startsWith(f.section.toLowerCase())).length > 0">
              <v-card class="pa-6" elevation="0" style="border-radius: 10px;height: 100%;border: none;background: #f5f5f5;">
                <v-row class="ml-0">
                  <v-col cols="12" sm="12" md="6" lg="4" xl="4" class="" v-for="(item) in mainMenuItems.filter(f => $router.currentRoute.path && f.section && $router.currentRoute.path.toLowerCase().startsWith(f.section.toLowerCase()))" :key="item.menuItemID">
                    <v-tooltip top>
                      <template v-slot:activator="{ on, attrs }">
                        <v-card v-bind="attrs" v-on="item.description !== null ? on: false" class="course" style="cursor:pointer;border-radius: 10px;border: none;" :href="item.href ? item.href : null">
                          <div class="course-preview" :style="item.gradient ? 'background: linear-gradient(225deg,' + item.color + ',' + item.colorGradient + ');' : (item.color ? 'background:' + item.color + ';': '')" style="border-radius: 0px;width: 75px;padding: 40px 20px;position: relative; background:linear-gradient(316.78deg, #2094ffb3, #033799b3);">
                            <h6 class="text-left d-flex" style="justify-content: center;">
                              <div class="mr-0" style="opacity: 1;">
                                <v-icon large v-if="item.linkImg && item.linkImg.toLowerCase().startsWith('fa'.toLowerCase())" color="white">mdi-link</v-icon>
                                <svgIcon v-else-if="item.linkImg && item.linkImg.toLowerCase().startsWith('svg'.toLowerCase())" fill="#ffffff" :iconName="item.linkImg" :width="28" :height="24"></svgIcon>
                                <v-icon v-else color="white">fas fa-book</v-icon>
                              </div>
                            </h6>
                          </div>
                          <div class="course-info" style="overflow: hidden;background: #ffffff;">
                            <h2 class="pr-2 pl-1 mb-3" style="font-family: 'Montserrat';font-style: normal;font-weight: 600;font-size: 20px;line-height: 24px;color: #004992;letter-spacing: 0.01em;max-width: 290px;">{{item.text}}</h2>
                            <div class="d-flex mt-1 ml-n1" style="position: absolute;bottom: 10px;margin-left: 1px !important;">
                            </div>
                          </div>
                        </v-card>
                      </template>
                      <span>{{item.description}}</span>
                    </v-tooltip>
                  </v-col>
                </v-row>
              </v-card>
            </v-col>
          </v-row>
        </div>
      </section>
      </v-fade-transition>
        <section v-if="isLogin && false" class="ma-6 d-flex ml-13 pt-6" style="">
          <span class="textHeader1Nagel">{{userFullName}}</span>
        </section>
        <section v-if="isLogin  && false" class="ma-6 d-flex" style="justify-content: center;">
          <v-row v-if="cuser.userID > 0" style="">
            <v-col cols="12" md="3" lg="3" class="mt-0" v-for="(item) in items.myItems" :key="item.menuItemID">
              <v-card
                  style="height: 224px;background: #9cb2e3;overflow: hidden;border-radius: 24px;cursor:pointer;"
                  dark
                  elevation="0"
                  :href="item.href ? item.href : null"
                >
                  <div class="d-flex flex-no-wrap justify-space-between">
                    <div class="ma-3" style="z-index: 1;">
                      <v-card-title class="textHeader1Nagel pr-0 mb-1" style="color: #010A24;font-weight: 500;font-size: 26px;word-break: break-word;">{{item.text}}</v-card-title>
                      <v-card-subtitle v-if="item.description" class="pr-0" style="color: #010A24;opacity: 0.6;font-size: 20px;line-height: 125%;font-size: 16px;max-width:160px;">{{item.description}}</v-card-subtitle>
                    </div>
                    <v-avatar
                      class="ma-0"
                      tile
                      size="auto"
                      style="position: absolute;right: 0;bottom:0"
                    >
                      <v-img v-if="item.img" class="mr-0" :style="item.fullImg || 'width: 172px;height: 155px;'" :src="baseUrl + 'img/icons/img/' + item.img + '.png'"/>
                    </v-avatar>
                  </div>
                </v-card>
            </v-col>
            <v-col cols="12"  class="mt-0">
              <v-card
                  style="height: 64px;background: #9cb2e3;overflow: hidden;border-radius: 24px;cursor:pointer;"
                  dark
                  elevation="0"
                  @click="logout()"
                >
                  <div class="d-flex flex-no-wrap justify-space-between">
                    <div class="ma-3 mt-1" style="z-index: 1;">
                      <v-card-title class="textHeader1Nagel pr-0 mb-1" style="color: #010A24;font-weight: 500;font-size: 26px;word-break: break-word;">Выйти из личного кабинета</v-card-title>
                      <!-- <v-card-subtitle v-if="item.description" class="pr-0" style="color: #010A24;opacity: 0.6;font-size: 20px;line-height: 125%;font-size: 16px;max-width:160px;">{{item.description}}</v-card-subtitle> -->
                    </div>
                    <!-- <v-avatar
                      class="ma-0"
                      tile
                      size="auto"
                      style="position: absolute;right: 0;bottom:0"
                    >
                      <v-img v-if="item.img" class="mr-0" :style="item.fullImg || 'width: 172px;height: 155px;'" :src="baseUrl + 'img/icons/img/' + item.img + '.png'"/>
                    </v-avatar> -->
                  </div>
                </v-card>
            </v-col>
          </v-row>
        </section>
        <section v-if="directoryMenuItems.length > 0" class="ma-6 d-flex ml-13 pt-6" style="">
          <span class="textHeader1Nagel">Меню</span>
        </section>
        <section class="ma-6 d-flex" style="justify-content: center;">
          <v-row style="">
            <v-col cols="12" md="3" lg="3" class="mt-0" v-for="(item) in directoryMenuItems" :key="item.menuItemID">
              <v-card
                  style="height: 224px;background: #9cb2e3;overflow: hidden;border-radius: 24px;cursor:pointer;"
                  dark
                  elevation="0"
                  :href="item.href ? item.href : null"
                >
                  <div class="d-flex flex-no-wrap justify-space-between">
                    <div class="ma-3" style="z-index: 1;">
                      <v-card-title class="textHeader1Nagel pr-0 mb-1" style="color: #010A24;font-weight: 500;font-size: 26px;word-break: break-word;">{{item.text}}</v-card-title>
                      <v-card-subtitle v-if="item.description" class="pr-0" style="color: #010A24;opacity: 0.6;font-size: 20px;line-height: 125%;font-size: 16px;max-width:160px;">{{item.description}}</v-card-subtitle>
                    </div>
                    <v-avatar
                      class="ma-0"
                      tile
                      size="auto"
                      style="position: absolute;right: 0;bottom:0"
                    >
                      <v-img v-if="item.img" class="mr-0" :style="item.fullImg || 'width: 172px;height: 155px;'" :src="baseUrl + 'img/icons/img/' + item.img + '.png'"/>
                    </v-avatar>
                  </div>
                </v-card>
            </v-col>
            <!-- mainMenuItems.filter(f => f.gradient && $router.currentRoute.path && f.section && $router.currentRoute.path.toLowerCase().startsWith(f.section.toLowerCase())).filter((f, index) => index <= 3)" :key="item.menuItemID" -->
          </v-row>
        </section>
        <section v-if="directoryItems.length > 0" class="ma-6 d-flex ml-13 pt-6" style="">
          <span class="textHeader1Nagel">Справочник</span>
        </section>
        <section class="ma-6 d-flex" style="justify-content: center;">
          <v-row style="">
            <!-- mainMenuItems.filter(f => f.gradient && $router.currentRoute.path && f.section && $router.currentRoute.path.toLowerCase().startsWith(f.section.toLowerCase())).filter((f, index) => index <= 3)" :key="item.menuItemID" -->
            <v-col cols="12" md="3" lg="3" class="mt-0" v-for="(item) in directoryItems" :key="item.menuItemID">
              <v-card
                  style="height: 224px;background: #9cb2e3;overflow: hidden;border-radius: 24px;cursor:pointer;"
                  dark
                  elevation="0"
                  :href="item.href ? item.href : null"
                >
                  <div class="d-flex flex-no-wrap justify-space-between">
                    <div class="ma-3" style="z-index: 1;">
                      <v-card-title class="textHeader1Nagel pr-0 mb-1" style="color: #010A24;font-weight: 500;font-size: 26px;word-break: break-word;">{{item.text}}</v-card-title>
                      <v-card-subtitle v-if="item.description" class="pr-0" style="color: #010A24;opacity: 0.6;font-size: 20px;line-height: 125%;font-size: 16px;max-width:160px;">{{item.description}}</v-card-subtitle>
                    </div>
                    <v-avatar
                      class="ma-0"
                      tile
                      size="auto"
                      style="position: absolute;right: 0;bottom:0"
                    >
                      <v-img v-if="item.img" class="mr-0" :style="item.fullImg || 'width: 172px;height: 155px;'" :src="baseUrl + 'img/icons/img/' + item.img + '.png'"/>
                    </v-avatar>
                  </div>
                </v-card>
            </v-col>
          </v-row>
        </section>
        <section v-if="directoryMoresItems.length > 0" class="ma-6 d-flex ml-13 pt-6" style="">
          <span class="textHeader1Nagel">Ещё</span>
        </section>
        <section class="ma-6 d-flex" style="justify-content: center;">
          <v-row style="">
            <!-- mainMenuItems.filter(f => f.gradient && $router.currentRoute.path && f.section && $router.currentRoute.path.toLowerCase().startsWith(f.section.toLowerCase())).filter((f, index) => index <= 3)" :key="item.menuItemID" -->
            <v-col cols="12" md="4" lg="4" class="mt-0" v-for="(item) in directoryMoresItems" :key="item.menuItemID">
              <v-card
                  style="height: 224px;background: #9cb2e3;overflow: hidden;border-radius: 24px;cursor:pointer;"
                  dark
                  elevation="0"
                  :href="item.href ? item.href : null"
                >
                  <div class="d-flex flex-no-wrap justify-space-between">
                    <div class="ma-3" style="z-index: 1;">
                      <v-card-title class="textHeader1Nagel pr-0 mb-1" style="color: #010A24;font-weight: 500;font-size: 26px;word-break: break-word;">{{item.text}}</v-card-title>
                      <v-card-subtitle v-if="item.description" class="pr-0" style="color: #010A24;opacity: 0.6;font-size: 20px;line-height: 125%;font-size: 16px;max-width:160px;">{{item.description}}</v-card-subtitle>
                    </div>
                    <v-avatar
                      class="ma-0"
                      tile
                      size="auto"
                      style="position: absolute;right: 0;bottom:0"
                    >
                      <v-img v-if="item.img" class="mr-0" :style="item.fullImg || 'width: 172px;height: 155px;'" :src="baseUrl + 'img/icons/img/' + item.img + '.png'"/>
                    </v-avatar>
                  </div>
                </v-card>
            </v-col>
          </v-row>
        </section>
      <v-fade-transition>
      <section v-if="loadedPage && isShowNews" class="module landing-reason parallax-bg pt-6" :style="'background-image: url(' + baseUrl + 'img/webapp/fon1.jpg);'" style="padding: 80px 0;background-repeat: no-repeat;background-position: 50% 50%;background-size: cover;">
        <div class="" :data-aos="!isMobile ? 'fade-up' : null" :class="{'aos-animate' : isIntersecting.section3, 'aos-init container container-section-landing' : !isMobile}">
          <v-row>
            <v-col cols="12" class="px-0">
              <!-- <h2 class="module-title font-alt">Календарь научных мероприятий - Максимка настало твоё время!!!</h2> -->
              <h2 class="module-title font-alt">Новости сайта</h2>
              <!-- <span class="section-divider" style="display: block;width: 60px;height: 3px;background: #243a51;margin: 20px auto;margin-bottom: 20px;"></span> -->
              <div class="mt-5" v-intersect="onIntersectSection3">
                <v-carousel v-if="news.length > 0" hide-delimiters transition="fade-transition" interval="1000" class="carouselNews" style="min-height: 600px;height: 100%;">
                  <template v-for="(item, index) in news">
                    <v-carousel-item v-if="(index + 1) % columns === 1 || columns === 1" :key="index" style="min-height: 600px;">
                      <v-row class="flex-nowrap px-15" style="height:100%">
                        <!-- <template v-for="(n,i) in columns"> -->
                          <template v-if="(+index) < news.length">
                            <v-col :key="iCol" v-for="(n,iCol) in columns" class="pa-5">
                                <v-card v-if="(+index+ iCol) < news.length" min-height="550px" :light="!$vuetify.theme.dark" flat style="border-radius: 15px !important;box-shadow: 2px -3px 6px rgba(0, 0, 0, 0.15), 0px 4px 9px rgba(0, 0, 0, 0.25) !important;">
                                  <img
                                    :src="news[+index+ iCol].srcImg"
                                    onerror="this.onerror=null;this.src='https://edu.donstu.ru/img/news/newss.jpg';"
                                    style="position: relative;width: 100%;max-height: 100vh;background-size: cover;background-position: 50%;"
                                  />
                                  <v-card-title style="word-break: break-word;">{{news[+index+ iCol].title}}</v-card-title>
                                  <v-card-text v-html="news[+index+ iCol].description" class="mb-6"></v-card-text>
                                </v-card>
                            </v-col>
                          </template>
                        <!-- </template> -->
                      </v-row>
                    </v-carousel-item>
                  </template>
                </v-carousel>
              </div>
            </v-col>
          </v-row>
        </div>
        <v-container v-if="false" style="max-width: 1400px;">
          <v-row class="py-0">
            <v-col cols="12" md="6" class="py-0" v-intersect="onIntersectSection3">
              <v-img
                :data-aos="!isMobile ? 'fade-right' : null"
                :data-aos-easing="!isMobile ? 'ease-out-back' : null"
                :class="{'aos-animate' : isIntersecting.section3, 'aos-init' : !isMobile}"
                :src="baseUrl + 'img/webapp/mobile_fon1.png?t=1'"
              ></v-img>
            </v-col>
            <v-col cols="12" md="6" class="py-0 px-8" :data-aos="!isMobile ? 'fade-left' : null" :class="{'aos-animate' : isIntersecting.section3, 'aos-init' : !isMobile}">
              <h2 class="module-title text-left" style="letter-spacing: 1px;">Теперь удобно пользоваться сайтом на разных устройствах!</h2>
              <p class="module-subtitle text-left white--text my-4 mb-7" style="position: relative;">Адаптивный дизайн сайта позволяет пользователям гораздо легче и удобнее пользоваться одним и тем же интерфейсом на разных устройствах.</p>
              <v-list-item class="white--text px-0">
                <v-list-item-action class="mr-4">
                  <v-icon class="white--text">mdi-cellphone</v-icon>
                </v-list-item-action>
                <v-list-item-content>
                  <v-list-item-title>Адаптивный дизайн сайта</v-list-item-title>
                </v-list-item-content>
              </v-list-item>
              <v-list-item class="white--text px-0">
                <v-list-item-action class="mr-4">
                  <v-icon class="white--text">mdi-calendar-text-outline</v-icon>
                </v-list-item-action>
                <v-list-item-content>
                  <v-list-item-title>Новые возможности для преподавателей</v-list-item-title>
                </v-list-item-content>
              </v-list-item>
              <v-list-item class="white--text px-0">
                <v-list-item-action class="mr-4">
                  <v-icon class="white--text">mdi-eye</v-icon>
                </v-list-item-action>
                <v-list-item-content>
                  <v-list-item-title>Обновлённый внешний вид большинства разделов</v-list-item-title>
                </v-list-item-content>
              </v-list-item>
              <v-list-item class="white--text px-0">
                <v-list-item-action class="mr-4">
                  <v-icon class="white--text">mdi-filter</v-icon>
                </v-list-item-action>
                <v-list-item-content>
                  <v-list-item-title>Фильтры для облегчения поиска нужной информации</v-list-item-title>
                </v-list-item-content>
              </v-list-item>
              <v-list-item class="white--text px-0">
                <v-list-item-action class="mr-4">
                  <v-icon class="white--text">mdi-image-multiple-outline</v-icon>
                </v-list-item-action>
                <v-list-item-content>
                  <v-list-item-title>И многое другое!</v-list-item-title>
                </v-list-item-content>
              </v-list-item>
              <!-- <v-btn
                class=""
                outlined
                color="white"
              >
                Outlined Button
              </v-btn> -->
            </v-col>
          </v-row>
        </v-container>
      </section>
      </v-fade-transition>
      <v-fade-transition>
      <v-footer
        v-if="loadedPage"
        dark
        padless
      >
        <v-card
          flat
          tile
          color="#224163"
          class="white--text text-center"
          style="width: 100%;"
        >
          <!-- <v-card-text>
            <v-btn
              v-for="icon in icons"
              :key="icon"
              class="mx-4 white--text"
              icon
            >
              <v-icon size="24px">
                {{ icon }}
              </v-icon>
            </v-btn>
          </v-card-text>

          <v-card-text class="white--text pt-0">
            Phasellus feugiat arcu sapien, et iaculis ipsum elementum sit amet. Mauris cursus commodo interdum. Praesent ut risus eget metus luctus accumsan id ultrices nunc. Sed at orci sed massa consectetur dignissim a sit amet dui. Duis commodo vitae velit et faucibus. Morbi vehicula lacinia malesuada. Nulla placerat augue vel ipsum ultrices, cursus iaculis dui sollicitudin. Vestibulum eu ipsum vel diam elementum tempor vel ut orci. Orci varius natoque penatibus et magnis dis parturient montes, nascetur ridiculus mus.
          </v-card-text> -->

          <v-divider></v-divider>

          <v-card-text :class="{'d-flex' : !isMobile}" class="container container-section-landing white--text mb-0" style="padding: 2.5rem 0;">
           <p class="footer__copyright">{{nameUniversity}} © {{ new Date().getFullYear() }}</p> <v-spacer></v-spacer><strong>Лаборатория ММИС</strong>
          </v-card-text>
        </v-card>
      </v-footer>
      </v-fade-transition>
      <section v-if="false">
          <div>
            <v-carousel
              cycle
              height="400"
              transition="fade-transition"
              hide-delimiter-background
              show-arrows-on-hover
            >
              <v-carousel-item>
                <v-sheet
                  height="100%"
                >
                  <v-row
                    class="fill-height mx-0"
                    align="center"
                    justify="center"
                  >
                    <div class="text-left" :class="{'text-center': isMobile}">
                      <p style="line-height: 30px;">
                          Студенты могут здесь просмотреть:<br>
                          - проверить правильность заполнения своего рейтинга, оценок и пересдач;
                          <br>
                          - узнать телефоны и номера аудиторий кафедр и деканатов;
                          <br>
                          - свою сводную ведомость успеваемости по итогам сессии;<br>
                          - расписание и график учебного процесса группы;
                          <br>
                          - свою электронную зачетную книжку.
                      </p>
                      <v-chip
                        class="ma-2"
                        color="#243a51"
                        text-color="white"
                      >
                        <v-icon left>
                          mdi-user
                        </v-icon>
                        <span class="author text-uppercase">Студент</span>
                      </v-chip>
                    </div>
                  </v-row>
                </v-sheet>
              </v-carousel-item>
              <v-carousel-item>
                <v-sheet
                  height="100%"
                >
                  <v-row
                    class="fill-height mx-0"
                    align="center"
                    justify="center"
                  >
                    <div class="text-left" :class="{'text-center': isMobile}">
                      <p style="line-height: 30px;">
                          Сотрудники и преподаватели университета могут получить информацию:
                          <br>
                          - найти информацию о студенте, группе, специальности, факультете и многое другое;<br>
                          - статистику по заполнению электронных рейтинговых ведомостей;<br>
                          - списки незаполненных и незакрытых ведомостей своей кафедры;<br>
                          - по контингенту студентов университета.
                      </p>
                      <v-chip
                        class="my-2"
                        color="#243a51"
                        text-color="white"
                      >
                        <v-icon left>
                          mdi-user
                        </v-icon>
                        <span class="author text-uppercase">Сотрудник и преподаватель</span>
                      </v-chip>
                    </div>
                  </v-row>
                </v-sheet>
              </v-carousel-item>
            </v-carousel>
          </div>
      </section>
      <v-fab-transition>
        <v-btn class="no-print" fab="fab" dark="dark" fixed="fixed" bottom="bottom" right="right"
                color="red" v-scroll="onScroll" v-show="fab" @click="toTop"
                :style="fabBottom ? { 'bottom': '65px'} : ''" style="right:6px">
          <v-icon>mdi-arrow-up</v-icon>
        </v-btn>
      </v-fab-transition>
      <v-fab-transition>
        <v-btn class="no-print" fab dark="dark" fixed bottom right color="red"
                style="bottom: 4px;right:6px" v-scroll="onScrollBottom" v-show="fabBottom"
                @click="toBottom">
          <v-icon>mdi-arrow-down</v-icon>
        </v-btn>
      </v-fab-transition>
    </div>
</template>

<script>
import svgIcon from '@/components/ui/svgIcon'
import menu from '@/helpers/api/menu'
import news from '@/helpers/api/news'
// Кэш загруженных иконок
const cache = new Map()
export default {
  name: 'Index',
  components: {
    svgIcon
  },
  data: () => ({
    colors: ['orange', 'blue', 'red', 'stud', 'purple'],
    items: {
      menus: [
        {menuItemID: 1, text: 'Личный кабинет', description: 'Профиль пользователя', img: 'champion', fullImg: true, href: '/webapp/#/' },
        {menuItemID: 2, text: 'Графики', description: 'Учебные графики групп', img: 'graph', fullImg: true, href: '/#/Graphs' },
        {menuItemID: 3, text: 'Оценки', description: 'Ведомости успеваемости', img: 'veds', fullImg: true, href: '/#/Veds'},
        //{menuItemID: 3, text: 'Журналы', description: null, img: 'journal', fullImg: true, href: '/webapp/#/Journals/JournalList'},
        {menuItemID: 4, text: 'Курсы', description: null, img: 'courses', fullImg: true, href: '/WebApp/#/courses/list'},
        {menuItemID: 5, text: 'Учебные планы', description: null, img: 'plans', fullImg: true, href: '/#/Plans'},
        {menuItemID: 6, text: 'Статистика', description: null, img: 'stat', fullImg: true, href: '/#/Statistics/k'},
        // {menuItemID: 7, text: 'Долги', description: 'Статистика задолженностей', img: 'debts', fullImg: true, href: '/stat/dolgfolder/dolgstudent.aspx'},
        {menuItemID: 8, text: 'Контакты', description: null, img: 'handbag', fullImg: true, href: '/#/Requisites'},
        //{menuItemID: 9, text: 'Моё портфолио', description: null, img: 'champion', fullImg: true, href: '/webapp/#/Portfolio/ListWorks'},
        // {menuItemID: 10, text: 'Сводные оценки', description: null, img: 'mark', fullImg: true, href: '/Totals/Default.aspx'},
        // {menuItemID: 11, text: 'Тестирование', description: null, img: 'cloak', fullImg: true, href: 'https://webtest.sssu.ru'},
        {menuItemID: 12, text: 'Анкетирование', description: null, img: 'questionnary', fullImg: true, href: '/WebApp/#/Questionnaires/List'},
        //{menuItemID: 13, text: 'Задолженности', description: null, img: 'deadline', fullImg: true, href: '/#/Stat/Debts'},
      ],
      directory: [
        {menuItemID: 1, text: 'Факультеты', description: null, img: 'folders', fullImg: true, href: '/#/Directory/Faculties'},
        {menuItemID: 5, text: 'Кафедры', description: null, img: 'folder2', fullImg: true, href: '/#/Directory/Departments'},
        //{menuItemID: 2, text: 'Группы', description: null, img: 'group', fullImg: true, href: '/#/Directory/Groups'},
        {menuItemID: 3, text: 'Специальности', description: null, img: 'spets', fullImg: true, href: '/#/Directory/Specialties'},
        {menuItemID: 4, text: 'Преподаватели', description: null, img: 'teachers', fullImg: true, href: '/#/Directory/Teachers'},
      ],
      mores: [
        {menuItemID: 1, text: 'Обратная связь', description: null, img: 'response', fullImg: true, href: '/webapp/#/feedback'},
        // {menuItemID: 2, text: 'Библиотека', description: null, img: 'book', fullImg: true, href: '/Library/LibDiscipline.aspx'}
      ],
      myItems: [
        // {menuItemID: 1, text: 'Поиск студента', description: null, img: 'search', fullImg: true, href: '/dek/Search.aspx'},
        {menuItemID: 2, text: 'Почта', description: null, img: 'email', fullImg: true, href: '/WebApp/#/mail/all'}
      ],
    },
    mainMenuItems: [],
    directoryMenuItems: [],
    directoryItems: [],
    directoryMoresItems: [],
    news: [],
    isShowNews: false,
    isIntersecting: {
      section1: false,
      section2: false,
      section3: true
    },
    isMobile: false,
    loadedPage: false,
    isSvgLogo: false,
    // Для кнопки выхода
    fab: false,
    fabBottom: false,
    icons: []
  }),
  methods: {
    // Methods Go to Top
    onScroll () {
      if (typeof window === 'undefined') return

      const top = window.pageYOffset ||
        document.documentElement.offsetTop ||
        0

      this.fab = top > 900
    },
    // Methods Go to Bottom
    onScrollBottom () {
      if (typeof window === 'undefined') return

      const bottom = window.pageYOffset ||
        document.documentElement.offsetTop ||
        0

      console.log(bottom)
      this.fabBottom = bottom > 300 && bottom < 700
    },
    toTop () {
      // this.$router.push({ hash: '' })
      this.$vuetify.goTo(0)
    },
    toBottom () {
      // this.$router.push({ hash: '' })
      this.$vuetify.goTo(9999)
    },
    // Загрузка содержимого SVG файла
    async loadFile (filepath) {
      this.isSvgLogo = false
      await this.getSvgIconText(filepath)
        .then(responseText => {
          this.isSvgLogo = responseText.includes('<svg')
          console.log('isSvg then', this.isSvgLogo)
          return this.isSvgLogo
        })
        .catch(error => {
          this.isSvgLogo = false
          console.log('isSvg error', this.isSvgLogo)
          return this.isSvgLogo
        })
    },

    // Получение SVG-файла в виде текстовой строки
    // + кэширование ранее загруженных файлов
    async getSvgIconText (filepath) {
      const url = filepath

      // Кэшируем загружаемые иконки
      // для сокращения запросов к серверу
      if (!cache.has(url)) {
        try {
          cache.set(url, fetch(url).then(r => r.text()))
        } catch (e) {
          cache.delete(url)
        }
      }
      // Возвращаем содержимое из кэша
      return cache.has(url)
        ? await cache.get(url)
        : Promise.reject(new Error('Нет SVG-файла в локальном кэше'))
    },
    onIntersectSection1 (entries, observer) {
      if (this.isMobile) return true
      this.isIntersecting.section1 = entries[0].isIntersecting
    },
    onIntersectSection2 (entries, observer) {
      if (this.isMobile) return true
      this.isIntersecting.section2 = entries[0].isIntersecting
    },
    onIntersectSection3 (entries, observer) {
      if (this.isMobile) return true
      this.isIntersecting.section3 = entries[0].isIntersecting
    },
    onResize () {
      if (window.innerWidth < 900) {
        this.isMobile = true
      } else {
        this.isMobile = false
      }
    },
  },
  computed: {
    baseUrl () {
      return process.env.BASE_URL
    },
    userFIO () {
      return this.$store.getters.userFIO
    },
    userFullName () {
      return this.$store.getters.userFullName
    },
    isLogin () {
      return this.$store.getters.isLogin
    },
    imgPath () {
      return this.initInfo && this.initInfo.imgPath ? this.initInfo.imgPath : 'fon.jpg'
    },
    initInfo () {
      return this.$store.state.initInfo
    },
    nameUniversity () {
      return this.$store.state.initInfo.nameUniversity ? this.$store.state.initInfo.nameUniversity.charAt(0).toUpperCase() + this.$store.state.initInfo.nameUniversity.slice(1).toLowerCase() : null
    },
    columns () {
      if (this.$vuetify.breakpoint.xl) {
        return 3
      }
      if (this.$vuetify.breakpoint.lg) {
        return 3
      }
      if (this.$vuetify.breakpoint.md) {
        return 2
      }
      return 1
    },
    cuser () {
      return this.$store.getters.cuser
    },
    authenticated () {
      return this.$store.getters.authenticated
    }
  },
  async created () {
    this.$vuetify.theme.dark = 'dark' === (localStorage.getItem('baseTheme') || 'light')
    this.loadFile('/img/webapp/logoSvg#logo.svg')
    let response = await news.getNews()
    this.news = response.news
    this.isShowNews = response.isShowNews
  },
  async mounted () {
    this.mainMenuItems = await menu.getMenuItems(1).finally(() => this.loadedPage = true)
    this.directoryItems = await menu.getDirectoryItems()
    if (this.directoryItems && this.directoryItems.length >= 0) {
      this.directoryItems = this.items.directory
    }
    this.directoryMenuItems = await menu.getDirectoryMenuItems()
    if (this.directoryMenuItems && this.directoryMenuItems.length >= 0) {
      this.directoryMenuItems = this.items.menus
    }
    this.directoryMoresItems = await menu.getDirectoryMoresItems()
  }
}
</script>
<style>
.footer__copyright {
  color: #ffffff;
  font-size: 1.0rem;
  font-weight: 400;
  letter-spacing: -.14px;
  /* line-height: 2rem; */
  opacity: .7;
}
.container-section-landing {
  display: block;
  margin: 0 auto;
  max-width: 90rem;
  width: calc(100% - 4rem);
  margin-bottom: 1.5rem;
}

@media (min-width: 2050px) {
  .container-section-landing {
    max-width: 100rem;
  }
}
@media (max-width: 1023px) {
  .container-section-landing {
    max-width:calc(100% - 4rem)
  }
}

@media (max-width: 767px) {
  .container-section-landing {
    max-width:calc(100% - 2.4rem);
    width: calc(100% - 2.4rem)
  }
}
@import url('https://fonts.googleapis.com/css?family=Montserrat:400,500,600,700&display=swap');
.course {
  background-color: #fff;
  border-radius: 10px;
  /* box-shadow: 0 10px 10px rgba(0, 0, 0, 0.2); */
  box-shadow: 0px 4px 8px -4px rgba(0, 0, 0, 0.2);
  display: flex !important;
  max-width: 100%;
  overflow: hidden;
  width: 700px;
  height: 100%;
  min-height: 110px;
}
.course h6 {
  /* opacity: 0.6; */
  margin: 0;
  text-align: left;
  text-transform: uppercase;
}

.course h2 {
  text-align: left;
  margin: 10px 0;
}

.course-preview {
  /* background-color: var(--v-stud-base) !important; */
  color: #fff;
  /* padding: 15px; */
  padding: 15px 10px;
  max-width: 250px;
}

.course-preview a {
  color: #fff !important;
  display: inline-block;
  font-size: 12px;
  opacity: 0.6;
  /* margin-top: 30px; */
  text-decoration: none;
}

.course-info {
  /* padding: 15px; */
  background: #F5F5F5;
  padding: 15px 10px;
  position: relative;
  width: 100%;
}
.textSite{
  letter-spacing: 0.03em;
  font-family: 'Montserrat';
  font-style: normal;
  font-weight: 600;
  font-size: 36px;
  line-height: 50px;
  text-transform: uppercase;
}
.site-title {
  font-size: 30px;
  font-weight: 600;
}
.site-title-mobile {
  font-size: 18px;
  font-weight: 300;
}
.carouselNews .v-carousel__item{
  min-height: 600px !important;
  height: 100% !important;
}
</style>
<style scoped>
.home-section {
  position: relative;
  background-color: #fff;
  background-repeat: no-repeat;
  background-position: center center;
  width: 100%;
  z-index: 0;
  background-size: cover;
}
.landing-header:before {
  position: absolute;
  background: linear-gradient(177.83deg, rgb(3 36 68 / 75%) 1.78%, rgb(4 89 218 / 40%) 98.18%);
  /* background: linear-gradient(177.83deg, rgb(3 36 68 / 15%) 1.78%, rgb(4 89 218 / 30%) 98.18%); */
  content: " ";
  height: 100%;
  width: 100%;
  left: 0;
  top: 0;
}
.font-alt {
  font-family: "Montserrat", "Roboto Condensed", sans-serif;
  text-transform: uppercase;
  letter-spacing: 2px;
}
.module-medium {
  padding: 75px 0px;
}
.module-title {
  position: relative;
  letter-spacing: 2px;
  text-align: center;
  font-weight: 400;
  font-size: 30px;
  color: #111;
}
.module-title + .module-subtitle {
  /* margin-top: -35px; */
}
.module-subtitle {
  text-align: center;
  font-size: 16px;
  color: #111;
}
.large-text {
  font-size: 24px !important;
}
/* / */
.parallax-bg {
  background-attachment: fixed;
  background-size: cover;
}
.landing-reason:before {
  position: absolute;
  content: " ";
  width: 100%;
  height: 100%;
  left: 0;
  top: 0;
  /* background-color: rgb(36 58 81 / 92%); */
  background-color: rgb(31 64 98 / 92%);
}
.module,
.module-small {
  position: relative;
  padding: 140px 0;
  background-repeat: no-repeat;
  background-position: 50% 50%;
  background-size: cover;
}

/* Module header */
.module-small {
  padding: 70px 0;
}

.module-extra-small {
  padding: 25px 0px;
}

.module-medium {
  padding: 75px 0px;
}

.holder-w {
  position: relative;
  display: table-cell;
  vertical-align: middle;
  height: 1px;
  width: 50%;
}

.holder-w:before {
  border-top: 1px solid #eaeaea;
  position: relative;
  display: block;
  content: "";
  top: 1px;
  height: 1px;
  width: 100%;
}
.landing-reason .module-title {
  /* color: #e6af4b; */
  color: #55e8ff;
}

.landing-reason .module-title + .module-subtitle {
  /* margin-top: -60px; */
}

.free-trial {
  background-color: rgba(88, 20, 158, 0.9);
  color: #FFFFFF;
}

.free-trial .color-golden {
  color: #e6af4b;
}

.landing-reason {
  color: #fff;
  font-size: 13px;
}

.landing-image-text {
  padding-top: 70px;
  padding-bottom: 0px;
}

.landing-image-text h2 {
  margin-top: 100px;
  margin-bottom: 15px;
}

.landing-screenshot:before {
  position: absolute;
  content: " ";
  width: 100%;
  height: 100%;
  left: 0;
  top: 0;
  background-color: rgba(66, 60, 130, 0.5);
}
/** */
@media (min-width: 1264px) {
  [data-aos][data-aos][data-aos-duration='50'],div[data-aos-duration='50'] [data-aos]{transition-duration:50ms}[data-aos][data-aos][data-aos-delay='50'],div[data-aos-delay='50'] [data-aos]{transition-delay:0}[data-aos][data-aos][data-aos-delay='50'].aos-animate,div[data-aos-delay='50'] [data-aos].aos-animate{transition-delay:50ms}[data-aos][data-aos][data-aos-duration='100'],div[data-aos-duration='100'] [data-aos]{transition-duration:.1s}[data-aos][data-aos][data-aos-delay='100'],div[data-aos-delay='100'] [data-aos]{transition-delay:0}[data-aos][data-aos][data-aos-delay='100'].aos-animate,div[data-aos-delay='100'] [data-aos].aos-animate{transition-delay:.1s}[data-aos][data-aos][data-aos-duration='150'],div[data-aos-duration='150'] [data-aos]{transition-duration:.15s}[data-aos][data-aos][data-aos-delay='150'],div[data-aos-delay='150'] [data-aos]{transition-delay:0}[data-aos][data-aos][data-aos-delay='150'].aos-animate,div[data-aos-delay='150'] [data-aos].aos-animate{transition-delay:.15s}[data-aos][data-aos][data-aos-duration='200'],div[data-aos-duration='200'] [data-aos]{transition-duration:.2s}[data-aos][data-aos][data-aos-delay='200'],div[data-aos-delay='200'] [data-aos]{transition-delay:0}[data-aos][data-aos][data-aos-delay='200'].aos-animate,div[data-aos-delay='200'] [data-aos].aos-animate{transition-delay:.2s}[data-aos][data-aos][data-aos-duration='250'],div[data-aos-duration='250'] [data-aos]{transition-duration:.25s}[data-aos][data-aos][data-aos-delay='250'],div[data-aos-delay='250'] [data-aos]{transition-delay:0}[data-aos][data-aos][data-aos-delay='250'].aos-animate,div[data-aos-delay='250'] [data-aos].aos-animate{transition-delay:.25s}[data-aos][data-aos][data-aos-duration='300'],div[data-aos-duration='300'] [data-aos]{transition-duration:.3s}[data-aos][data-aos][data-aos-delay='300'],div[data-aos-delay='300'] [data-aos]{transition-delay:0}[data-aos][data-aos][data-aos-delay='300'].aos-animate,div[data-aos-delay='300'] [data-aos].aos-animate{transition-delay:.3s}[data-aos][data-aos][data-aos-duration='350'],div[data-aos-duration='350'] [data-aos]{transition-duration:.35s}[data-aos][data-aos][data-aos-delay='350'],div[data-aos-delay='350'] [data-aos]{transition-delay:0}[data-aos][data-aos][data-aos-delay='350'].aos-animate,div[data-aos-delay='350'] [data-aos].aos-animate{transition-delay:.35s}[data-aos][data-aos][data-aos-duration='400'],div[data-aos-duration='400'] [data-aos]{transition-duration:.4s}[data-aos][data-aos][data-aos-delay='400'],div[data-aos-delay='400'] [data-aos]{transition-delay:0}[data-aos][data-aos][data-aos-delay='400'].aos-animate,div[data-aos-delay='400'] [data-aos].aos-animate{transition-delay:.4s}[data-aos][data-aos][data-aos-duration='450'],div[data-aos-duration='450'] [data-aos]{transition-duration:.45s}[data-aos][data-aos][data-aos-delay='450'],div[data-aos-delay='450'] [data-aos]{transition-delay:0}[data-aos][data-aos][data-aos-delay='450'].aos-animate,div[data-aos-delay='450'] [data-aos].aos-animate{transition-delay:.45s}[data-aos][data-aos][data-aos-duration='500'],div[data-aos-duration='500'] [data-aos]{transition-duration:.5s}[data-aos][data-aos][data-aos-delay='500'],div[data-aos-delay='500'] [data-aos]{transition-delay:0}[data-aos][data-aos][data-aos-delay='500'].aos-animate,div[data-aos-delay='500'] [data-aos].aos-animate{transition-delay:.5s}[data-aos][data-aos][data-aos-duration='550'],div[data-aos-duration='550'] [data-aos]{transition-duration:.55s}[data-aos][data-aos][data-aos-delay='550'],div[data-aos-delay='550'] [data-aos]{transition-delay:0}[data-aos][data-aos][data-aos-delay='550'].aos-animate,div[data-aos-delay='550'] [data-aos].aos-animate{transition-delay:.55s}[data-aos][data-aos][data-aos-duration='600'],div[data-aos-duration='600'] [data-aos]{transition-duration:.6s}[data-aos][data-aos][data-aos-delay='600'],div[data-aos-delay='600'] [data-aos]{transition-delay:0}[data-aos][data-aos][data-aos-delay='600'].aos-animate,div[data-aos-delay='600'] [data-aos].aos-animate{transition-delay:.6s}[data-aos][data-aos][data-aos-duration='650'],div[data-aos-duration='650'] [data-aos]{transition-duration:.65s}[data-aos][data-aos][data-aos-delay='650'],div[data-aos-delay='650'] [data-aos]{transition-delay:0}[data-aos][data-aos][data-aos-delay='650'].aos-animate,div[data-aos-delay='650'] [data-aos].aos-animate{transition-delay:.65s}[data-aos][data-aos][data-aos-duration='700'],div[data-aos-duration='700'] [data-aos]{transition-duration:.7s}[data-aos][data-aos][data-aos-delay='700'],div[data-aos-delay='700'] [data-aos]{transition-delay:0}[data-aos][data-aos][data-aos-delay='700'].aos-animate,div[data-aos-delay='700'] [data-aos].aos-animate{transition-delay:.7s}[data-aos][data-aos][data-aos-duration='750'],div[data-aos-duration='750'] [data-aos]{transition-duration:.75s}[data-aos][data-aos][data-aos-delay='750'],div[data-aos-delay='750'] [data-aos]{transition-delay:0}[data-aos][data-aos][data-aos-delay='750'].aos-animate,div[data-aos-delay='750'] [data-aos].aos-animate{transition-delay:.75s}[data-aos][data-aos][data-aos-duration='800'],div[data-aos-duration='800'] [data-aos]{transition-duration:.8s}[data-aos][data-aos][data-aos-delay='800'],div[data-aos-delay='800'] [data-aos]{transition-delay:0}[data-aos][data-aos][data-aos-delay='800'].aos-animate,div[data-aos-delay='800'] [data-aos].aos-animate{transition-delay:.8s}[data-aos][data-aos][data-aos-duration='850'],div[data-aos-duration='850'] [data-aos]{transition-duration:.85s}[data-aos][data-aos][data-aos-delay='850'],div[data-aos-delay='850'] [data-aos]{transition-delay:0}[data-aos][data-aos][data-aos-delay='850'].aos-animate,div[data-aos-delay='850'] [data-aos].aos-animate{transition-delay:.85s}[data-aos][data-aos][data-aos-duration='900'],div[data-aos-duration='900'] [data-aos]{transition-duration:.9s}[data-aos][data-aos][data-aos-delay='900'],div[data-aos-delay='900'] [data-aos]{transition-delay:0}[data-aos][data-aos][data-aos-delay='900'].aos-animate,div[data-aos-delay='900'] [data-aos].aos-animate{transition-delay:.9s}[data-aos][data-aos][data-aos-duration='950'],div[data-aos-duration='950'] [data-aos]{transition-duration:.95s}[data-aos][data-aos][data-aos-delay='950'],div[data-aos-delay='950'] [data-aos]{transition-delay:0}[data-aos][data-aos][data-aos-delay='950'].aos-animate,div[data-aos-delay='950'] [data-aos].aos-animate{transition-delay:.95s}[data-aos][data-aos][data-aos-duration='1000'],div[data-aos-duration='1000'] [data-aos]{transition-duration:1s}[data-aos][data-aos][data-aos-delay='1000'],div[data-aos-delay='1000'] [data-aos]{transition-delay:0}[data-aos][data-aos][data-aos-delay='1000'].aos-animate,div[data-aos-delay='1000'] [data-aos].aos-animate{transition-delay:1s}[data-aos][data-aos][data-aos-duration='1050'],div[data-aos-duration='1050'] [data-aos]{transition-duration:1.05s}
[data-aos][data-aos][data-aos-delay='1050'],div[data-aos-delay='1050'] [data-aos]{transition-delay:0}[data-aos][data-aos][data-aos-delay='1050'].aos-animate,div[data-aos-delay='1050'] [data-aos].aos-animate{transition-delay:1.05s}[data-aos][data-aos][data-aos-duration='1100'],div[data-aos-duration='1100'] [data-aos]{transition-duration:1.1s}[data-aos][data-aos][data-aos-delay='1100'],div[data-aos-delay='1100'] [data-aos]{transition-delay:0}[data-aos][data-aos][data-aos-delay='1100'].aos-animate,div[data-aos-delay='1100'] [data-aos].aos-animate{transition-delay:1.1s}[data-aos][data-aos][data-aos-duration='1150'],div[data-aos-duration='1150'] [data-aos]{transition-duration:1.15s}[data-aos][data-aos][data-aos-delay='1150'],div[data-aos-delay='1150'] [data-aos]{transition-delay:0}[data-aos][data-aos][data-aos-delay='1150'].aos-animate,div[data-aos-delay='1150'] [data-aos].aos-animate{transition-delay:1.15s}[data-aos][data-aos][data-aos-duration='1200'],div[data-aos-duration='1200'] [data-aos]{transition-duration:1.2s}[data-aos][data-aos][data-aos-delay='1200'],div[data-aos-delay='1200'] [data-aos]{transition-delay:0}[data-aos][data-aos][data-aos-delay='1200'].aos-animate,div[data-aos-delay='1200'] [data-aos].aos-animate{transition-delay:1.2s}[data-aos][data-aos][data-aos-duration='1250'],div[data-aos-duration='1250'] [data-aos]{transition-duration:1.25s}[data-aos][data-aos][data-aos-delay='1250'],div[data-aos-delay='1250'] [data-aos]{transition-delay:0}[data-aos][data-aos][data-aos-delay='1250'].aos-animate,div[data-aos-delay='1250'] [data-aos].aos-animate{transition-delay:1.25s}[data-aos][data-aos][data-aos-duration='1300'],div[data-aos-duration='1300'] [data-aos]{transition-duration:1.3s}[data-aos][data-aos][data-aos-delay='1300'],div[data-aos-delay='1300'] [data-aos]{transition-delay:0}[data-aos][data-aos][data-aos-delay='1300'].aos-animate,div[data-aos-delay='1300'] [data-aos].aos-animate{transition-delay:1.3s}[data-aos][data-aos][data-aos-duration='1350'],div[data-aos-duration='1350'] [data-aos]{transition-duration:1.35s}[data-aos][data-aos][data-aos-delay='1350'],div[data-aos-delay='1350'] [data-aos]{transition-delay:0}[data-aos][data-aos][data-aos-delay='1350'].aos-animate,div[data-aos-delay='1350'] [data-aos].aos-animate{transition-delay:1.35s}[data-aos][data-aos][data-aos-duration='1400'],div[data-aos-duration='1400'] [data-aos]{transition-duration:1.4s}[data-aos][data-aos][data-aos-delay='1400'],div[data-aos-delay='1400'] [data-aos]{transition-delay:0}[data-aos][data-aos][data-aos-delay='1400'].aos-animate,div[data-aos-delay='1400'] [data-aos].aos-animate{transition-delay:1.4s}[data-aos][data-aos][data-aos-duration='1450'],div[data-aos-duration='1450'] [data-aos]{transition-duration:1.45s}[data-aos][data-aos][data-aos-delay='1450'],div[data-aos-delay='1450'] [data-aos]{transition-delay:0}[data-aos][data-aos][data-aos-delay='1450'].aos-animate,div[data-aos-delay='1450'] [data-aos].aos-animate{transition-delay:1.45s}[data-aos][data-aos][data-aos-duration='1500'],div[data-aos-duration='1500'] [data-aos]{transition-duration:1.5s}[data-aos][data-aos][data-aos-delay='1500'],div[data-aos-delay='1500'] [data-aos]{transition-delay:0}[data-aos][data-aos][data-aos-delay='1500'].aos-animate,div[data-aos-delay='1500'] [data-aos].aos-animate{transition-delay:1.5s}[data-aos][data-aos][data-aos-duration='1550'],div[data-aos-duration='1550'] [data-aos]{transition-duration:1.55s}[data-aos][data-aos][data-aos-delay='1550'],div[data-aos-delay='1550'] [data-aos]{transition-delay:0}[data-aos][data-aos][data-aos-delay='1550'].aos-animate,div[data-aos-delay='1550'] [data-aos].aos-animate{transition-delay:1.55s}[data-aos][data-aos][data-aos-duration='1600'],div[data-aos-duration='1600'] [data-aos]{transition-duration:1.6s}[data-aos][data-aos][data-aos-delay='1600'],div[data-aos-delay='1600'] [data-aos]{transition-delay:0}[data-aos][data-aos][data-aos-delay='1600'].aos-animate,div[data-aos-delay='1600'] [data-aos].aos-animate{transition-delay:1.6s}[data-aos][data-aos][data-aos-duration='1650'],div[data-aos-duration='1650'] [data-aos]{transition-duration:1.65s}[data-aos][data-aos][data-aos-delay='1650'],div[data-aos-delay='1650'] [data-aos]{transition-delay:0}[data-aos][data-aos][data-aos-delay='1650'].aos-animate,div[data-aos-delay='1650'] [data-aos].aos-animate{transition-delay:1.65s}[data-aos][data-aos][data-aos-duration='1700'],div[data-aos-duration='1700'] [data-aos]{transition-duration:1.7s}[data-aos][data-aos][data-aos-delay='1700'],div[data-aos-delay='1700'] [data-aos]{transition-delay:0}[data-aos][data-aos][data-aos-delay='1700'].aos-animate,div[data-aos-delay='1700'] [data-aos].aos-animate{transition-delay:1.7s}[data-aos][data-aos][data-aos-duration='1750'],div[data-aos-duration='1750'] [data-aos]{transition-duration:1.75s}[data-aos][data-aos][data-aos-delay='1750'],div[data-aos-delay='1750'] [data-aos]{transition-delay:0}[data-aos][data-aos][data-aos-delay='1750'].aos-animate,div[data-aos-delay='1750'] [data-aos].aos-animate{transition-delay:1.75s}[data-aos][data-aos][data-aos-duration='1800'],div[data-aos-duration='1800'] [data-aos]{transition-duration:1.8s}[data-aos][data-aos][data-aos-delay='1800'],div[data-aos-delay='1800'] [data-aos]{transition-delay:0}[data-aos][data-aos][data-aos-delay='1800'].aos-animate,div[data-aos-delay='1800'] [data-aos].aos-animate{transition-delay:1.8s}[data-aos][data-aos][data-aos-duration='1850'],div[data-aos-duration='1850'] [data-aos]{transition-duration:1.85s}[data-aos][data-aos][data-aos-delay='1850'],div[data-aos-delay='1850'] [data-aos]{transition-delay:0}[data-aos][data-aos][data-aos-delay='1850'].aos-animate,div[data-aos-delay='1850'] [data-aos].aos-animate{transition-delay:1.85s}[data-aos][data-aos][data-aos-duration='1900'],div[data-aos-duration='1900'] [data-aos]{transition-duration:1.9s}[data-aos][data-aos][data-aos-delay='1900'],div[data-aos-delay='1900'] [data-aos]{transition-delay:0}[data-aos][data-aos][data-aos-delay='1900'].aos-animate,div[data-aos-delay='1900'] [data-aos].aos-animate{transition-delay:1.9s}[data-aos][data-aos][data-aos-duration='1950'],div[data-aos-duration='1950'] [data-aos]{transition-duration:1.95s}[data-aos][data-aos][data-aos-delay='1950'],div[data-aos-delay='1950'] [data-aos]{transition-delay:0}[data-aos][data-aos][data-aos-delay='1950'].aos-animate,div[data-aos-delay='1950'] [data-aos].aos-animate{transition-delay:1.95s}[data-aos][data-aos][data-aos-duration='2000'],div[data-aos-duration='2000'] [data-aos]{transition-duration:2s}[data-aos][data-aos][data-aos-delay='2000'],div[data-aos-delay='2000'] [data-aos]{transition-delay:0}[data-aos][data-aos][data-aos-delay='2000'].aos-animate,div[data-aos-delay='2000'] [data-aos].aos-animate{transition-delay:2s}[data-aos][data-aos][data-aos-duration='2050'],div[data-aos-duration='2050'] [data-aos]{transition-duration:2.05s}[data-aos][data-aos][data-aos-delay='2050'],div[data-aos-delay='2050'] [data-aos]{transition-delay:0}[data-aos][data-aos][data-aos-delay='2050'].aos-animate,div[data-aos-delay='2050'] [data-aos].aos-animate{transition-delay:2.05s}[data-aos][data-aos][data-aos-duration='2100'],div[data-aos-duration='2100'] [data-aos]{transition-duration:2.1s}[data-aos][data-aos][data-aos-delay='2100'],div[data-aos-delay='2100'] [data-aos]{transition-delay:0}[data-aos][data-aos][data-aos-delay='2100'].aos-animate,div[data-aos-delay='2100'] [data-aos].aos-animate{transition-delay:2.1s}[data-aos][data-aos][data-aos-duration='2150'],div[data-aos-duration='2150'] [data-aos]{transition-duration:2.15s}[data-aos][data-aos][data-aos-delay='2150'],div[data-aos-delay='2150'] [data-aos]{transition-delay:0}[data-aos][data-aos][data-aos-delay='2150'].aos-animate,div[data-aos-delay='2150'] [data-aos].aos-animate{transition-delay:2.15s}[data-aos][data-aos][data-aos-duration='2200'],div[data-aos-duration='2200'] [data-aos]{transition-duration:2.2s}[data-aos][data-aos][data-aos-delay='2200'],div[data-aos-delay='2200'] [data-aos]{transition-delay:0}[data-aos][data-aos][data-aos-delay='2200'].aos-animate,div[data-aos-delay='2200'] [data-aos].aos-animate{transition-delay:2.2s}[data-aos][data-aos][data-aos-duration='2250'],div[data-aos-duration='2250'] [data-aos]{transition-duration:2.25s}[data-aos][data-aos][data-aos-delay='2250'],div[data-aos-delay='2250'] [data-aos]{transition-delay:0}[data-aos][data-aos][data-aos-delay='2250'].aos-animate,div[data-aos-delay='2250'] [data-aos].aos-animate{transition-delay:2.25s}[data-aos][data-aos][data-aos-duration='2300'],div[data-aos-duration='2300'] [data-aos]{transition-duration:2.3s}[data-aos][data-aos][data-aos-delay='2300'],div[data-aos-delay='2300'] [data-aos]{transition-delay:0}[data-aos][data-aos][data-aos-delay='2300'].aos-animate,div[data-aos-delay='2300'] [data-aos].aos-animate{transition-delay:2.3s}[data-aos][data-aos][data-aos-duration='2350'],div[data-aos-duration='2350'] [data-aos]{transition-duration:2.35s}[data-aos][data-aos][data-aos-delay='2350'],div[data-aos-delay='2350'] [data-aos]{transition-delay:0}[data-aos][data-aos][data-aos-delay='2350'].aos-animate,div[data-aos-delay='2350'] [data-aos].aos-animate{transition-delay:2.35s}[data-aos][data-aos][data-aos-duration='2400'],div[data-aos-duration='2400'] [data-aos]{transition-duration:2.4s}[data-aos][data-aos][data-aos-delay='2400'],div[data-aos-delay='2400'] [data-aos]{transition-delay:0}[data-aos][data-aos][data-aos-delay='2400'].aos-animate,div[data-aos-delay='2400'] [data-aos].aos-animate{transition-delay:2.4s}[data-aos][data-aos][data-aos-duration='2450'],div[data-aos-duration='2450'] [data-aos]{transition-duration:2.45s}[data-aos][data-aos][data-aos-delay='2450'],div[data-aos-delay='2450'] [data-aos]{transition-delay:0}[data-aos][data-aos][data-aos-delay='2450'].aos-animate,div[data-aos-delay='2450'] [data-aos].aos-animate{transition-delay:2.45s}[data-aos][data-aos][data-aos-duration='2500'],div[data-aos-duration='2500'] [data-aos]{transition-duration:2.5s}[data-aos][data-aos][data-aos-delay='2500'],
div[data-aos-delay='2500'] [data-aos]{transition-delay:0}[data-aos][data-aos][data-aos-delay='2500'].aos-animate,div[data-aos-delay='2500'] [data-aos].aos-animate{transition-delay:2.5s}[data-aos][data-aos][data-aos-duration='2550'],div[data-aos-duration='2550'] [data-aos]{transition-duration:2.55s}[data-aos][data-aos][data-aos-delay='2550'],div[data-aos-delay='2550'] [data-aos]{transition-delay:0}[data-aos][data-aos][data-aos-delay='2550'].aos-animate,div[data-aos-delay='2550'] [data-aos].aos-animate{transition-delay:2.55s}[data-aos][data-aos][data-aos-duration='2600'],div[data-aos-duration='2600'] [data-aos]{transition-duration:2.6s}[data-aos][data-aos][data-aos-delay='2600'],div[data-aos-delay='2600'] [data-aos]{transition-delay:0}[data-aos][data-aos][data-aos-delay='2600'].aos-animate,div[data-aos-delay='2600'] [data-aos].aos-animate{transition-delay:2.6s}[data-aos][data-aos][data-aos-duration='2650'],div[data-aos-duration='2650'] [data-aos]{transition-duration:2.65s}[data-aos][data-aos][data-aos-delay='2650'],div[data-aos-delay='2650'] [data-aos]{transition-delay:0}[data-aos][data-aos][data-aos-delay='2650'].aos-animate,div[data-aos-delay='2650'] [data-aos].aos-animate{transition-delay:2.65s}[data-aos][data-aos][data-aos-duration='2700'],div[data-aos-duration='2700'] [data-aos]{transition-duration:2.7s}[data-aos][data-aos][data-aos-delay='2700'],div[data-aos-delay='2700'] [data-aos]{transition-delay:0}[data-aos][data-aos][data-aos-delay='2700'].aos-animate,div[data-aos-delay='2700'] [data-aos].aos-animate{transition-delay:2.7s}[data-aos][data-aos][data-aos-duration='2750'],div[data-aos-duration='2750'] [data-aos]{transition-duration:2.75s}[data-aos][data-aos][data-aos-delay='2750'],div[data-aos-delay='2750'] [data-aos]{transition-delay:0}[data-aos][data-aos][data-aos-delay='2750'].aos-animate,div[data-aos-delay='2750'] [data-aos].aos-animate{transition-delay:2.75s}[data-aos][data-aos][data-aos-duration='2800'],div[data-aos-duration='2800'] [data-aos]{transition-duration:2.8s}[data-aos][data-aos][data-aos-delay='2800'],div[data-aos-delay='2800'] [data-aos]{transition-delay:0}[data-aos][data-aos][data-aos-delay='2800'].aos-animate,div[data-aos-delay='2800'] [data-aos].aos-animate{transition-delay:2.8s}[data-aos][data-aos][data-aos-duration='2850'],div[data-aos-duration='2850'] [data-aos]{transition-duration:2.85s}[data-aos][data-aos][data-aos-delay='2850'],div[data-aos-delay='2850'] [data-aos]{transition-delay:0}[data-aos][data-aos][data-aos-delay='2850'].aos-animate,div[data-aos-delay='2850'] [data-aos].aos-animate{transition-delay:2.85s}[data-aos][data-aos][data-aos-duration='2900'],div[data-aos-duration='2900'] [data-aos]{transition-duration:2.9s}[data-aos][data-aos][data-aos-delay='2900'],div[data-aos-delay='2900'] [data-aos]{transition-delay:0}[data-aos][data-aos][data-aos-delay='2900'].aos-animate,div[data-aos-delay='2900'] [data-aos].aos-animate{transition-delay:2.9s}[data-aos][data-aos][data-aos-duration='2950'],div[data-aos-duration='2950'] [data-aos]{transition-duration:2.95s}[data-aos][data-aos][data-aos-delay='2950'],div[data-aos-delay='2950'] [data-aos]{transition-delay:0}[data-aos][data-aos][data-aos-delay='2950'].aos-animate,div[data-aos-delay='2950'] [data-aos].aos-animate{transition-delay:2.95s}[data-aos][data-aos][data-aos-duration='3000'],div[data-aos-duration='3000'] [data-aos]{transition-duration:3s}[data-aos][data-aos][data-aos-delay='3000'],div[data-aos-delay='3000'] [data-aos]{transition-delay:0}[data-aos][data-aos][data-aos-delay='3000'].aos-animate,div[data-aos-delay='3000'] [data-aos].aos-animate{transition-delay:3s}[data-aos][data-aos][data-aos-easing=linear],div[data-aos-easing=linear] [data-aos]{transition-timing-function:cubic-bezier(.25,.25,.75,.75)}[data-aos][data-aos][data-aos-easing=ease],div[data-aos-easing=ease] [data-aos]{transition-timing-function:ease}[data-aos][data-aos][data-aos-easing=ease-in],div[data-aos-easing=ease-in] [data-aos]{transition-timing-function:ease-in}[data-aos][data-aos][data-aos-easing=ease-out],div[data-aos-easing=ease-out] [data-aos]{transition-timing-function:ease-out}[data-aos][data-aos][data-aos-easing=ease-in-out],div[data-aos-easing=ease-in-out] [data-aos]{transition-timing-function:ease-in-out}[data-aos][data-aos][data-aos-easing=ease-in-back],div[data-aos-easing=ease-in-back] [data-aos]{transition-timing-function:cubic-bezier(.6,-.28,.735,.045)}[data-aos][data-aos][data-aos-easing=ease-out-back],div[data-aos-easing=ease-out-back] [data-aos]{transition-timing-function:cubic-bezier(.175,.885,.32,1.275)}[data-aos][data-aos][data-aos-easing=ease-in-out-back],div[data-aos-easing=ease-in-out-back] [data-aos]{transition-timing-function:cubic-bezier(.68,-.55,.265,1.55)}[data-aos][data-aos][data-aos-easing=ease-in-sine],div[data-aos-easing=ease-in-sine] [data-aos]{transition-timing-function:cubic-bezier(.47,0,.745,.715)}[data-aos][data-aos][data-aos-easing=ease-out-sine],div[data-aos-easing=ease-out-sine] [data-aos]{transition-timing-function:cubic-bezier(.39,.575,.565,1)}[data-aos][data-aos][data-aos-easing=ease-in-out-sine],div[data-aos-easing=ease-in-out-sine] [data-aos]{transition-timing-function:cubic-bezier(.445,.05,.55,.95)}[data-aos][data-aos][data-aos-easing=ease-in-quad],div[data-aos-easing=ease-in-quad] [data-aos]{transition-timing-function:cubic-bezier(.55,.085,.68,.53)}[data-aos][data-aos][data-aos-easing=ease-out-quad],div[data-aos-easing=ease-out-quad] [data-aos]{transition-timing-function:cubic-bezier(.25,.46,.45,.94)}[data-aos][data-aos][data-aos-easing=ease-in-out-quad],div[data-aos-easing=ease-in-out-quad] [data-aos]{transition-timing-function:cubic-bezier(.455,.03,.515,.955)}[data-aos][data-aos][data-aos-easing=ease-in-cubic],div[data-aos-easing=ease-in-cubic] [data-aos]{transition-timing-function:cubic-bezier(.55,.085,.68,.53)}[data-aos][data-aos][data-aos-easing=ease-out-cubic],div[data-aos-easing=ease-out-cubic] [data-aos]{transition-timing-function:cubic-bezier(.25,.46,.45,.94)}[data-aos][data-aos][data-aos-easing=ease-in-out-cubic],div[data-aos-easing=ease-in-out-cubic] [data-aos]{transition-timing-function:cubic-bezier(.455,.03,.515,.955)}[data-aos][data-aos][data-aos-easing=ease-in-quart],div[data-aos-easing=ease-in-quart] [data-aos]{transition-timing-function:cubic-bezier(.55,.085,.68,.53)}[data-aos][data-aos][data-aos-easing=ease-out-quart],div[data-aos-easing=ease-out-quart] [data-aos]{transition-timing-function:cubic-bezier(.25,.46,.45,.94)}[data-aos][data-aos][data-aos-easing=ease-in-out-quart],div[data-aos-easing=ease-in-out-quart] [data-aos]{transition-timing-function:cubic-bezier(.455,.03,.515,.955)}[data-aos^=fade][data-aos^=fade]{opacity:0;transition-property:opacity,transform}[data-aos^=fade][data-aos^=fade].aos-animate{opacity:1;transform:translate(0)}[data-aos=fade-up]{transform:translateY(100px)}[data-aos=fade-down]{transform:translateY(-100px)}
[data-aos=fade-right]{transform:translate(-100px)}
[data-aos=fade-left]{transform:translate(-100px)  }
[data-aos=fade-up-right]{transform:translate(-100px,100px)}
[data-aos=fade-up-left]{transform:translate(100px,100px)}
[data-aos=fade-down-right]{transform:translate(-100px,-100px)}
[data-aos=fade-down-left]{transform:translate(100px,-100px)}
[data-aos^=zoom][data-aos^=zoom]{opacity:0;transition-property:opacity,transform}[data-aos^=zoom][data-aos^=zoom]
.aos-animate{opacity:1;transform:translate(0) scale(1)}
[data-aos=zoom-in]{transform:scale(.6)}[data-aos=zoom-in-up]{transform:translateY(100px) scale(.6)}[data-aos=zoom-in-down]{transform:translateY(-100px) scale(.6)}
[data-aos=zoom-in-right]{transform:translate(-100px) scale(.6)}[data-aos=zoom-in-left]{transform:translate(100px) scale(.6)}[data-aos=zoom-out]{transform:scale(1.2)}
[data-aos=zoom-out-up]{transform:translateY(100px) scale(1.2)}[data-aos=zoom-out-down]{transform:translateY(-100px) scale(1.2)}
[data-aos=zoom-out-right]{transform:translate(-100px) scale(1.2)}[data-aos=zoom-out-left]{transform:translate(100px) scale(1.2)}
[data-aos^=slide][data-aos^=slide]{transition-property:transform}[data-aos^=slide][data-aos^=slide].aos-animate{transform:translate(0)}
[data-aos=slide-up]{transform:translateY(100%)}[data-aos=slide-down]{transform:translateY(-100%)}[data-aos=slide-right]{transform:translateX(-100%)}[data-aos=slide-left]{transform:translateX(100%)}[data-aos^=flip][data-aos^=flip]{backface-visibility:hidden;transition-property:transform}[data-aos=flip-left]{transform:perspective(2500px) rotateY(-100deg)}[data-aos=flip-left].aos-animate{transform:perspective(2500px) rotateY(0)}[data-aos=flip-right]{transform:perspective(2500px) rotateY(100deg)}[data-aos=flip-right].aos-animate{transform:perspective(2500px) rotateY(0)}[data-aos=flip-up]{transform:perspective(2500px) rotateX(-100deg)}[data-aos=flip-up].aos-animate{transform:perspective(2500px) rotateX(0)}[data-aos=flip-down]{transform:perspective(2500px) rotateX(100deg)}[data-aos=flip-down].aos-animate{transform:perspective(2500px) rotateX(0)}
/*# animate aos.css*/

}
</style>
